// Matches the Unicode replacement character (U+FFFD) in either form:
//   - the character itself (when bytes EF BF BD were decoded as UTF-8)
//   - the 3-char Latin-1 mojibake (EF BF BD bytes misdecoded as Latin-1)
const INVALID_CHAR_PATTERN = new RegExp(
    String.fromCharCode(0xfffd) + "|" + String.fromCharCode(0xef, 0xbf, 0xbd),
    "g"
);

export const sanitizeInvalidCharacters = (value) => {
    if (typeof value !== "string") {
        return value;
    }
    return value.replace(INVALID_CHAR_PATTERN, "");
};

const isPlainObject = (value) => {
    if (value === null || typeof value !== "object") {
        return false;
    }
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};

// Recursively sanitizes all string values in a JSON-like structure.
// Object keys are left untouched (they're API contract, not user input).
// Non-plain objects (Date, moment, class instances, etc.) pass through
// unchanged to preserve their type.
export const sanitizeInvalidCharactersDeep = (value) => {
    if (typeof value === "string") {
        return value.replace(INVALID_CHAR_PATTERN, "");
    }
    if (Array.isArray(value)) {
        return value.map(sanitizeInvalidCharactersDeep);
    }
    if (isPlainObject(value)) {
        const result = {};
        for (const key of Object.keys(value)) {
            result[key] = sanitizeInvalidCharactersDeep(value[key]);
        }
        return result;
    }
    return value;
};
